// extracted by mini-css-extract-plugin
export default {"maskPlaceholder":"ChS_DxzlxepmsngkG24c","maskOnly":"vCjiUKA13poeuOUwIuAP"};